module.exports = __webpack_public_path__ + "img/play.2e8aa9d5.svg";